export default __webpack_public_path__ + "static/media/element_76.9734de1e.webp";